export function makeFilterManager(filtersKey) {
  return {
    getFilters: () => {
      let parsedValue = null;
      try {
        parsedValue = JSON.parse(sessionStorage.getItem(filtersKey));
      } catch (error) {
        console.error(error);
      }
      return parsedValue;
    },
    setFilters: value => sessionStorage.setItem(filtersKey, JSON.stringify(value)),
    clearFilters: () => sessionStorage.setItem(filtersKey, null),
  };
}

export class FilterManager {
  constructor({windowName}) {
    this.windowName = windowName;
    try {
      this.filters = JSON.parse(sessionStorage.getItem(windowName));
    } catch (error) {
      console.error(error);
    }
  }

  setFilters(filters) {
    this.filters = filters;
    sessionStorage.setItem(this.windowName, JSON.stringify(filters));
  }

  clearFilters() {
    this.filters = null;
    sessionStorage.setItem(this.windowName, null);
  }
}
